module.exports = __webpack_public_path__ + "static/media/Girl.a8867076.png";